export const documentsUID = 'ry3GdjAz7mfVr7yOhNuMAVPhNQq2';
export const documentsEmail = 'documents@finessepaint.com';
